import { useTranslation } from 'react-i18next';

const StatusControl = ({value}) => {
    const { t } = useTranslation();

    const statusObj = {
        "active": t('active'),
        "yettostart": t('yet_to_start'),
        "yet_to_start": t('yet_to_start'),
        "expired": t('expired'),
        "finished": t('finished')
    }

    return !!statusObj[value.toLowerCase()] ? statusObj[value.toLowerCase()] : value;
}

export default StatusControl;